import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { DirectTranslationService, LanguageReadModel } from 'src/applazy/generatedmodules/translation/api';
import { BaseTranslationDataService } from 'src/applazy/services/basetranslationdata.service';
import { SaveHostLanguagesCommand } from '../models/translation/saveHostLanguages.model';

@Injectable({
    providedIn: 'root'
})
export class DirectTranslationDataService implements BaseTranslationDataService {
    constructor(
        private translationService: DirectTranslationService
    ) {

    }
    getAuthLanguages(loadUrl: boolean): Observable<LanguageReadModel[]> {
        return this.translationService.apiV1DirectTranslationLangsAllGet('1.0', loadUrl);
    }
    saveAuthLanguages(languages: string[]) {
        return this.translationService.apiV1TranslationLangsSavePortalPost('1.0', new SaveHostLanguagesCommand(languages));
    }
    getWordByKey(keys: string[], language: string) {
        return this.translationService.apiV1TranslationLanguageLanguagePost(language, '1.0', keys);
    }
}
